define('redactor/redactor',['require','exports','module','./src/view/redactor.view'],function(require, exports, module) {
  var redactor = {
    RedactorView: require('./src/view/redactor.view')
  };

  module.exports = redactor;
});

